import { render } from "./reports-tab.vue?vue&type=template&id=8136054a&scoped=true"
import script from "./reports-tab.vue?vue&type=script&lang=js"
export * from "./reports-tab.vue?vue&type=script&lang=js"

import "./reports-tab.vue?vue&type=style&index=0&id=8136054a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8136054a"]])

export default __exports__